// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1EjfI","unreadBadge":"styles_unreadBadge__37Bzg","modalContent":"styles_modalContent__1xaEL","modal":"styles_modal__8kJjH"};